"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorHandler = errorHandler;

var _effects = require("redux-saga/effects");

var _errorCodes = require("../../../constants/errorCodes");

var _actions = require("../../error/actions");

var _actions2 = require("../../auth/actions");

var _apiRequest = require("./apiRequest");

var _NotificationUtils = require("../../../utils/NotificationUtils");

var modalActions = _interopRequireWildcard(require("../../modal/actions"));

var _modalTypes = require("../../../constants/modalTypes");

var _AbortError = require("../../../common/errors/AbortError");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(errorHandler);

function errorHandler(error, endpoint, method, params) {
  return regeneratorRuntime.wrap(function errorHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = error.code;
          _context.next = _context.t0 === _errorCodes.ERROR_CODES.NOT_ALLOWED_FOR_THIS_PARTNER ? 3 : _context.t0 === _errorCodes.ERROR_CODES.VALIDATION_ERROR ? 5 : _context.t0 === _errorCodes.ERROR_CODES.INVALID_CREDENTIALS ? 8 : _context.t0 === _errorCodes.ERROR_CODES.ACCESS_TOKEN_EXPIRED ? 11 : _context.t0 === _errorCodes.ERROR_CODES.INVALID_ACCESS_TOKEN ? 11 : _context.t0 === _errorCodes.ERROR_CODES.ACCESS_FORBIDDEN ? 14 : _context.t0 === _errorCodes.ERROR_CODES.NO_AUTH_TOKEN_EXISTS ? 14 : _context.t0 === _errorCodes.ERROR_CODES.INVALID_REFRESH_TOKEN ? 19 : _context.t0 === _errorCodes.ERROR_CODES.REFRESH_FAILURE ? 19 : _context.t0 === _errorCodes.ERROR_CODES.REFRESH_TOKEN_EXPIRED ? 19 : _context.t0 === _errorCodes.ERROR_CODES.DATA_ACCESS_EXCEPTION ? 24 : _context.t0 === _errorCodes.ERROR_CODES.TIMEOUT ? 24 : _context.t0 === _errorCodes.ERROR_CODES.HTTP_ERROR ? 24 : _context.t0 === _errorCodes.ERROR_CODES.ABORT ? 25 : 26;
          break;

        case 3:
          (0, _NotificationUtils.showError)(error.message);
          throw error;

        case 5:
          _context.next = 7;
          return (0, _effects.put)((0, _actions.setError)({
            code: error.code,
            message: error.message
          }));

        case 7:
          throw error;

        case 8:
          _context.next = 10;
          return (0, _effects.put)((0, _actions.setError)({
            code: error.code,
            message: 'auth/forbidden/title' // TODO: rename translation

          }));

        case 10:
          throw error;

        case 11:
          _context.next = 13;
          return (0, _effects.call)(_apiRequest.apiRequest, endpoint, method, params);

        case 13:
          return _context.abrupt("return", _context.sent);

        case 14:
          _context.next = 16;
          return (0, _effects.put)((0, _actions.setError)({
            code: error.code,
            message: error.message,
            withRetry: false
          }));

        case 16:
          _context.next = 18;
          return (0, _effects.put)((0, _actions2.unauthorizeSaga)());

        case 18:
          throw error;

        case 19:
          _context.next = 21;
          return (0, _effects.put)((0, _actions.setError)({
            code: error.code,
            message: 'auth/inactivityLogout/text'
          }));

        case 21:
          _context.next = 23;
          return (0, _effects.put)((0, _actions2.unauthorizeSaga)());

        case 23:
          throw error;

        case 24:
          throw error;

        case 25:
          throw new _AbortError.AbortError(error.message);

        case 26:
          _context.next = 28;
          return (0, _effects.put)(modalActions.show("error/errorMessage", error.message, _modalTypes.MODAL_TYPES.ERROR));

        case 28:
          throw error;

        case 29:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}